export const EXTRA_SMALL: number = 480;
export const SMALL: number = 768;
export const MEDIUM: number = 992;
export const LARGE: number = 1200;
